<template>
  <header>
    <div class="container">
      <div class="row row-wrap">
        <div class="header-account col text-left">
          <img src="@/assets/logo-heppi.png" srcset="@/assets/logo-heppi@2x.png 2x" style="height: 40px">
          <h2>{{ account }}</h2>
        </div>
        <div class="header-title col-auto text-right">
          <h1 v-html="description" />
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'documentHeader',
  props: ['account', 'description']
}
</script>
